import React, { useState, useEffect } from 'react'
import { Table, Spin } from 'antd'
import { compare } from './diff_compare_object'

const DiffTableBoardReport = ({ dataBefore, dataAfter, type, fileMap }) => {
  const [diffData, setDiffData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const computeDiff = async () => {
      setLoading(true)
      try {
        // Ensure we have valid input
        const beforeData = dataBefore || '{}'
        const afterData = dataAfter || '{}'

        // Call compare function and await it since it's async
        const result = await compare(type, beforeData, afterData, {})

        // Ensure result is always an array
        if (Array.isArray(result)) {
          setDiffData(result)
        } else {
          console.warn('Compare returned unexpected type:', typeof result)
          setDiffData([])
        }
      } catch (error) {
        console.error('Error computing diff:', error)
        setDiffData([])
      } finally {
        setLoading(false)
      }
    }

    computeDiff()
  }, [dataBefore, dataAfter, type])

  const columns = [
    {
      title: 'Trường thông tin',
      dataIndex: 'field',
      key: 'field',
      width: '20%',
    },
    {
      title: 'Giá trị cũ',
      dataIndex: 'fieldValueBefore',
      key: 'fieldValueBefore',
      width: '40%',
      render: text => (
        <div dangerouslySetInnerHTML={{ __html: text || 'Không có' }} />
      ),
    },
    {
      title: 'Giá trị mới',
      dataIndex: 'fieldValueAfter',
      key: 'fieldValueAfter',
      width: '40%',
      render: text => (
        <div dangerouslySetInnerHTML={{ __html: text || 'Không có' }} />
      ),
    },
  ]

  if (loading) {
    return <Spin size="small" />
  }

  // Don't render table if no data
  if (!diffData || diffData.length === 0) {
    return (
      <div style={{ padding: '10px', color: '#999' }}>Không có thay đổi</div>
    )
  }

  return (
    <Table
      dataSource={diffData}
      columns={columns}
      pagination={false}
      rowKey={(record, index) => `${record.field}-${index}`}
      size="small"
      bordered
    />
  )
}

export default DiffTableBoardReport
